// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#222834","menuText":"#c0c4cc"};